import site from '../../site';
import globals from '../../globals';
import actionTypes from '../constants/action-types';

const changeHTML = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.CHANGE_HTML: {
      const { newHTML, globalsToUpdate } = action.payload;
      const state = store.getState();
      const pageId = site.selectors.getActivePageId(state);

      globals.helpers.saveGlobals(globalsToUpdate);
      store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default changeHTML;
